import { g as c } from "./index-E8vB_04G.js";
import { generateCsrPem as d } from "./authentication.js";
import "./index-b-LDu0Rp.js";
import "./nacl-fast-DmSj04OB.js";
import "ddc";
import { a as i } from "./utils-dinPOBnH.js";
import "sgx-ias-verifier";
import "./config.js";
import "./index-Buti0PLx.js";
import "./index-jyncyKHm.js";
import "./index-Ch-rSMgZ.js";
class k {
  auth;
  clientProtocols;
  connection;
  client;
  constructor(t, n, r, e) {
    this.clientProtocols = r, this.auth = t, this.client = n, this.connection = e;
  }
  /**
   * Request a pkiEndorsement from the enclave. Enclave will verify if
   * the pub key used in the session is certified in the provided
   * certificateChainPem.
   */
  async pkiEndorsement(t) {
    const n = [3, 4, 5, 6], r = i(this.clientProtocols, n), e = await this.sendEndorsementRequest(
      {
        pkiEndorsementRequest: {
          certificateChainPem: t
        }
      },
      r
    );
    if (!e.pkiEndorsementResponse)
      throw new Error(`PkiEndorsementRequest failed, got ${e}`);
    const s = e.pkiEndorsementResponse;
    if (!s.pkiEndorsement)
      throw new Error("PkiEndorsementRequest failed, pkiEndorsement is unset");
    const o = s.pkiEndorsement;
    if (!o.endorsementCertificateDer)
      throw new Error("Missing enclaveEndorsement in response");
    return o;
  }
  async decentriqPkiEndorsement() {
    const t = d(this.client.userEmail, this.auth.keypair), n = await this.client.getUserCertificate(
      this.client.userEmail,
      t
    );
    return this.pkiEndorsement(new TextEncoder().encode(n));
  }
  /**
   * Request a dcrSecretEndorsement from the enclave. The enclave will
   * certify that the holder of the pub key used in the session
   * knows the secret corresponding to the returned dcrSecretId.
   */
  async dcrSecretEndorsement(t) {
    const n = [3, 4, 5, 6], r = i(this.clientProtocols, n), e = await this.sendEndorsementRequest(
      {
        dcrSecretEndorsementRequest: {
          dcrSecret: t
        }
      },
      r
    );
    if (!e.dcrSecretEndorsementResponse)
      throw new Error(`DcrSecretEndorsementRequest failed, got ${e}`);
    const s = e.dcrSecretEndorsementResponse;
    if (!s.dcrSecretEndorsement || !s.dcrSecretId)
      throw new Error("DcrSecretEndorsementRequest failed, dcrSecret is unset");
    return [
      s.dcrSecretEndorsement,
      s.dcrSecretId
    ];
  }
  async sendEndorsementRequest(t, n) {
    const r = await this.connection.sendRequest(
      c.GcgRequest.create({
        endorsementRequest: t
      }),
      n,
      this.auth
    );
    if (r.length !== 1)
      throw new Error("Malformed response");
    const e = r[0];
    if (e.gcgResponse !== "endorsementResponse" || e.endorsementResponse === null || e.endorsementResponse === void 0)
      throw new Error(`Request failed, got ${e}`);
    return e.endorsementResponse;
  }
}
export {
  k as Endorser
};
//# sourceMappingURL=endorsement.js.map
